import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { formatCurrency } from 'utils/format';

type DebitInvoicePanelProps = {
    debitInvoiceId: string;
    debitInvoiceNumber: string;
    currency: string;
    totalAmount: number;
};

const DebitInvoicePanel: FC<DebitInvoicePanelProps> = ({
    debitInvoiceId,
    totalAmount,
    currency,
    debitInvoiceNumber,
}: DebitInvoicePanelProps) => {
    const { t: translate } = useTranslation(['invoices']);
    const navigate = useNavigate();

    const goToDebitInvoice = () => {
        navigate(`/invoices/${debitInvoiceId}/summary`);
    };

    return (
        <Fragment>
            <Box mb={1}>
                <Box>
                    <Typography variant="subtitle2">{translate('THIS_IS_A_CREDIT_INVOICE_FOR')}</Typography>
                </Box>
            </Box>

            <Box mb={2}>
                <Divider />
            </Box>

            <Box display="flex">
                <Box flex="1 0 75%">
                    <Link onClick={goToDebitInvoice} href="#">
                        {translate('INVOICE')}: {debitInvoiceNumber}
                    </Link>
                </Box>
                <Box alignSelf="flex-end">
                    <Typography variant="subtitle2">{formatCurrency(totalAmount, currency)}</Typography>
                </Box>
            </Box>
        </Fragment>
    );
};

export default DebitInvoicePanel;
